<template>
    <div class="staticpage">

        <div class="staticpage_area">            

            <div class="staticpage_div">
                <div class="static_page_title">{{label["404_title"]}}</div>

                <div class="staticpage_error_icon_div"></div>
                <div class="staticpage_inner_area">
                    <div class="staticpage_content" v-html="label['404_msg']"></div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
export default {
  computed: {
    info() {
      return this.$root.info;
    },
    label() {
      return this.$root.getLabel();
    }
  },
  components: {},
  created() {

    this.info.loading = false;
    this.$root.getCurrentPathName();

  },
  methods: {}
};
</script>
